import { FC } from 'react'
import { useTranslate } from 'react-admin'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Typography from '@mui/material/Typography'
import { MergeNodeData, WorkflowNodeData } from '../types'
import { themeColor } from '../../../layout/theme/color'

interface MergeConfigProps {
  data: MergeNodeData
  onUpdate: (data: Partial<WorkflowNodeData>) => void
}

const MergeConfig: FC<MergeConfigProps> = ({ data, onUpdate }) => {
  const translate = useTranslate()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label={translate('workflow.config.label')}
        value={data.label}
        onChange={(e) => onUpdate({ label: e.target.value })}
        size="small"
        fullWidth
      />

      <Box>
        <Typography variant="caption" sx={{ fontWeight: 600, color: themeColor.slate60, mb: 0.5, display: 'block' }}>
          {translate('workflow.config.mergeStrategy')}
        </Typography>
        <ToggleButtonGroup
          value={data.strategy}
          exclusive
          onChange={(_e, val: string | null) => val && onUpdate({ strategy: val as 'wait_all' | 'first_result' })}
          size="small"
          fullWidth
        >
          <ToggleButton value="wait_all" sx={{ textTransform: 'none' }}>
            {translate('workflow.config.waitAll')}
          </ToggleButton>
          <ToggleButton value="first_result" sx={{ textTransform: 'none' }}>
            {translate('workflow.config.firstResult')}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  )
}

export default MergeConfig
